<div dir="{{languageDir}}">
<div class="production-db-content">
  <div class="content-top-box">
    <ul class="breadcrumb">
      <ul class="breadcrumb">
        <li class="breadcrumb-item" *ngFor="let breadcrumItem of breadcrumList">
          <a
            class="breadcrumb-link"
            [routerLink]="breadcrumItem.Url"
            [id]="breadcrumItem.id"
            (click)="DisplayRightmenu(breadcrumItem.id, breadcrumItem.Url)"
            >{{lang.getTransalatedValue(breadcrumItem.text)}}</a
          >
        </li>
      </ul>
    </ul>
    <div class="title-row-flex-both-end">
      <h1 class="main-title">
        {{ langObj ? langObj?.ProductionPlan : ("ProductionPlan" | translate) }}
      </h1>
    </div>
  </div>
  <ngx-spinner
    bdColor="rgba(0, 0, 0, 0.8)"
    template=" <img src='assets/images/spinner.gif' />"
  ></ngx-spinner>
  <form [formGroup]="productionPlanningForm">
    <div class="content-top-row content-top-row-order-processing">
      <!-- GROUP -->
      <mat-form-field
        appearence="fill"
        class="top-row-first-filed-item top-row-first-filed-item-order-processing"
      >
        <mat-label>
          {{ langObj ? langObj?.Group : ("Group" | translate) }}
        </mat-label>
        <mat-select
          formControlName="group"
          placeholder="{{ langObj ? langObj?.Group : ('Group' | translate) }}"
          panelClass="testClass"
          name="Status"
          (selectionChange)="getPlants()"
        >
          <mat-select-filter
            [placeholder]="'Search'"
            [displayMember]="'EG_Desc'"
            [array]="GroupList"
            (filteredReturn)="filteredGroups = $event"
          ></mat-select-filter>
          <mat-option
            *ngFor="let group of filteredGroups"
            [value]="group.EG_Id"
          >
            {{ group.EG_Desc }}
          </mat-option>
        </mat-select>
        <mat-error>{{
          langObj ? langObj?.GroupIsRequired : ("GroupIsRequired" | translate)
        }}</mat-error>
      </mat-form-field>

      <!-- plant  -->
      <mat-form-field
        appearence="fill"
        class="top-row-first-filed-item top-row-first-filed-item-order-processing w-48"
      >
        <mat-label>
          {{ langObj ? langObj?.Plant : ("Plant" | translate) }}
        </mat-label>
        <mat-select
          formControlName="plant"
          placeholder="{{ langObj ? langObj?.Plant : ('Plant' | translate) }}"
          panelClass="testClass"
          name="Status"
        >
          <mat-select-filter
            [placeholder]="'Search'"
            [displayMember]="'PT_Desc'"
            [array]="PlantList"
            (filteredReturn)="filteredPlants = $event"
          ></mat-select-filter>
          <mat-option
            *ngFor="let plant of filteredPlants"
            [value]="plant.PT_Id"
          >
            {{ plant.PT_Desc }}
          </mat-option>
        </mat-select>
        <mat-error>
          {{
            langObj ? langObj?.PlantIsRequired : ("PlantIsRequired" | translate)
          }}
        </mat-error>
      </mat-form-field>

      <button
        [disabled]="!IsWrite"
        (click)="filterData()"
        pTooltip="Search"
        class="save"
        tooltipPosition="top"
      >
        <img src="assets/images/search.png" alt="" width="20px" height="20px" />
      </button>

      <button
        [disabled]="!IsWrite"
        type="button"
        class="clear-filter"
        pTooltip="Pody Fields"
        (click)="podyPopup()"
      >
        <i class="fa fa-first-order" aria-hidden="true"></i>
      </button>
      <button
        [disabled]="!IsWrite"
        type="button"
        class="clear-filter"
        pTooltip="Operation"
        (click)="operationPopup()"
      >
        <i class="fa fa-bar-chart"></i>
      </button>
      <button
        [disabled]="!IsWrite"
        type="button"
        class="csvImg clear-filter"
        pTooltip="BOM"
        (click)="BOMPopup()"
      >
        <img src="assets/images/popup.png" width="18px" height="18px" />
      </button>
    </div>
  </form>

  <mat-card-content>
    <ag-grid-angular
      style="width: 100%; height: 35vw"
      class="ag-theme-alpine"
      [rowData]="rowData"
      [columnDefs]="columnDefs"
      (gridReady)="onGridReady($event)"
      [gridOptions]="gridOptions"
      [pagination]="true"
      [paginationPageSize]="10"
      (selectionChanged)="onSelectionChanged()"
      [rowSelection]="rowSelection"
    >
      >
    </ag-grid-angular>
  </mat-card-content>
</div>

<ng-template #podyField>
  <div mat-dialog-title>
    <div class="d-flex justify-content-between align-items-center">
      <h2>
        {{ langObj ? langObj?.PodyFields : ("PodyFields" | translate) }}
      </h2>
      <button
        mat-mini-fab
        mat-button
        mat-dialog-close
        color="warn"
        title="close"
      >
        <i class="fa fa-times" style="color: #fff"></i>
      </button>
    </div>
    <mat-card-content>
      <ag-grid-angular
        style="width: 100%; height: 50vw"
        class="ag-theme-alpine"
        [rowData]="podyData"
        [columnDefs]="podyDefs"
        (gridReady)="onGridReady($event)"
        [gridOptions]="gridOptions"
        [pagination]="true"
        [paginationPageSize]="10"
      >
        >
      </ag-grid-angular>
    </mat-card-content>
  </div>

  <mat-card-content></mat-card-content>
</ng-template>
<ng-template #operation>
  <div mat-dialog-title>
    <div class="d-flex justify-content-between align-items-center">
      <h2>
        {{ langObj ? langObj?.OperationData : ("OperationData" | translate) }}
      </h2>
      <button
        mat-mini-fab
        mat-button
        mat-dialog-close
        color="warn"
        title="close"
      >
        <i class="fa fa-times" style="color: #fff"></i>
      </button>
    </div>
  </div>

  <mat-card-content>
    <ag-grid-angular
      style="width: 100%; height: 50vw"
      class="ag-theme-alpine"
      [rowData]="operationData"
      [columnDefs]="operationDefs"
      (gridReady)="onGridReady($event)"
      [gridOptions]="gridOptions"
      [pagination]="true"
      [paginationPageSize]="10"
    >
      >
    </ag-grid-angular>
  </mat-card-content></ng-template
>
<ng-template #bom>
  <div mat-dialog-title>
    <div class="d-flex justify-content-between align-items-center">
      <h2>
        {{ langObj ? langObj?.BOMData : ("BOMData" | translate) }}
      </h2>
      <button
        mat-mini-fab
        mat-button
        mat-dialog-close
        color="warn"
        title="close"
      >
        <i class="fa fa-times" style="color: #fff"></i>
      </button>
    </div>
  </div>

  <mat-card-content>
    <ag-grid-angular
      style="width: 100%; height: 30vw"
      class="ag-theme-alpine"
      [rowData]="bomData"
      [columnDefs]="bomDefs"
      (gridReady)="onGridReady($event)"
      [gridOptions]="gridOptions"
      [pagination]="true"
      [paginationPageSize]="10"
    >
      >
    </ag-grid-angular>
  </mat-card-content></ng-template
>
</div>